import algoliasearch from 'algoliasearch/lite';
import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';

export default function getSearchClient() {
  if (process.env.VUE_APP_SCOUT_DRIVER === 'meilisearch') {
    return instantMeiliSearch(
      process.env.VUE_APP_MEILISEARCH_HOST,
      process.env.VUE_APP_MEILISEARCH_KEY,
      {
        finitePagination: true,
      },
    ).searchClient;
  }
  return algoliasearch(
    process.env.VUE_APP_ALGOLIA_APP_ID,
    process.env.VUE_APP_ALGOLIA_SECRET,
  );
}
